import {
  ActionIcon, Card, DetailStack, HStack, ICON_PENCIL_OUTLINE, ICON_TRASH_CAN_OUTLINE, Stack, Text,
} from '@doveit/bricks';
import React from 'react';
import { HRRecall, JobApplication } from '../../../providers/api/dtos';
import UpdateHRRecallStatus from '../update-hr-recall-status/UpdateHRRecallStatus';
import UpsertHRRecallAction, { UpsertHRRecallActionProps } from '../upsert-hr-recall-action/UpsertHRRecallAction';
import HRRecallAvatar from '../../components/hr-recall-avatar/HRRecallAvatar';
import DateViewer from '../../../components/date-viewer/DateViewer';
import DeleteHRCalendarEventAction, { DeleteHRCalendarEventActionProps } from '../delete-hr-calendar-event/DeleteHRCalendarEvent';

export interface ViewHRRecallCardProps extends React.AriaAttributes {
  hrRecall: HRRecall,
  jobApplication: JobApplication,
  canUpdate?: boolean,
  canDelete?: boolean,
  onUpdate?: UpsertHRRecallActionProps['onSuccess'];
  onDelete?: DeleteHRCalendarEventActionProps['onSuccess'];
}

const ViewHRRecallCard: React.FC<ViewHRRecallCardProps> = ({
  hrRecall: recall,
  jobApplication,
  canUpdate = false,
  canDelete = false,
  onUpdate,
  onDelete,
  ...rest
}) => (
  <Card
    aria-label="view-hr-recall-card"
    {...rest}
  >
    <Card.Header
      primaryActions={[
        canUpdate && (
          <UpsertHRRecallAction
            jobApplication={jobApplication}
            hrRecall={recall}
            canUpdate={canUpdate}
            onSuccess={onUpdate}
          >
            {({ openModal, isSaving }) => (
              <ActionIcon
                icon={{ path: ICON_PENCIL_OUTLINE }}
                label="Modifica recall"
                aria-label="Azione per modificare la recall"
                onClick={openModal}
                loading={isSaving}
                size="S"
              />
            )}
          </UpsertHRRecallAction>
        ),
        canDelete && recall.id && (
          <DeleteHRCalendarEventAction
            hrCalendarEventId={recall.id}
            onSuccess={onDelete}
          >
            {({ openModal, isSaving }) => (
              <ActionIcon
                icon={{ path: ICON_TRASH_CAN_OUTLINE }}
                label="Elimina recall"
                aria-label="Azione per eliminare la recall"
                onClick={openModal}
                loading={isSaving}
                size="S"
              />
            )}
          </DeleteHRCalendarEventAction>
        ),
      ]}
    >
      <HStack gap={100} wrap="nowrap">
        <HRRecallAvatar size="S" />
        <DetailStack label="Recall">
          <DateViewer
            stringDate={recall.date}
            withHour
            checkIfToday
            withStrong
          />
        </DetailStack>
      </HStack>
    </Card.Header>
    <Card.Content>
      <Stack gap={150}>
        <div>
          <UpdateHRRecallStatus
            hrRecall={recall}
            showAsBadge={canUpdate}
          />
        </div>
        {recall.note && (
          <Text.BodySmall aria-label="Nota della recall">
            {recall.note}
          </Text.BodySmall>
        )}
      </Stack>
    </Card.Content>
  </Card>
);

export default ViewHRRecallCard;
